import React from 'react';

import { detectionDetail } from '../compute';
import {
  fmtPtz, fmtTileRC, tilePtz,
} from '../helpers';
import pageStyle from '../style.module.scss';
import style from './style.module.scss';

/** Invisible hit target — frame is stroked on MosaicCanvas. */
const DetectionHit = ({ box, tile, onOpenDetail }) => {
  const {
    Top, Left, Width, Height,
  } = box.BoundingBox;
  const area = Math.max(0.0001, (Width || 0) * (Height || 0));
  const zIndex = Math.min(99, Math.max(2, Math.round(2 / Math.sqrt(area))));

  return (
    <button
      type="button"
      aria-label={box.label}
      data-crowd-box=""
      className={style.boxHit}
      style={{
        top: `${Top * 100}%`,
        left: `${Left * 100}%`,
        width: `${Width * 100}%`,
        height: `${Height * 100}%`,
        zIndex,
      }}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation();
        const detail = detectionDetail(box, tile);
        if (detail) onOpenDetail?.(detail);
      }}
    />
  );
};

/** One tile cell — DOM buttons align to AWS BoundingBox % over the canvas mosaic. */
const TileView = ({
  tile,
  scan,
  boxes,
  selectedLabels,
  showBoxes = true,
  onOpenDetail,
  tileKey,
  boxKeyPrefix,
}) => {
  const ptz = tilePtz(tile, scan);
  const visible = showBoxes
    ? (boxes || []).filter((b) => b?.BoundingBox && selectedLabels?.has(b.label))
    : [];

  return (
    <div
      className={`${style.tile} ${style.tileOverlay}`}
      data-tile-key={tileKey}
      data-row={tile.row}
      data-col={tile.col}
      data-index={tile.index}
      data-pan={fmtPtz(ptz.pan)}
      data-tilt={fmtPtz(ptz.tilt)}
      data-zoom={fmtPtz(ptz.zoom)}
      title={fmtTileRC(tile.row, tile.col)}
    >
      {visible.length ? (
        <div className={pageStyle.boxes}>
          {visible.map((box) => (
            <DetectionHit
              key={box.id}
              box={box}
              tile={boxKeyPrefix ? { ...tile, _scanId: boxKeyPrefix } : tile}
              onOpenDetail={onOpenDetail}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default TileView;
